<template>
  <div>
    <RadioGroup v-model="createdUser.mode" @on-change="createdUserChanged">
      <Radio label="1">
        <span>Нэвтрэх нэр (Бүртгэл №)</span>
      </Radio>
      <Radio label="2">
        <span>Регистр №</span>
      </Radio>
      <Radio label="3">
        <span>Нэр</span>
      </Radio>
    </RadioGroup>
    <Input v-model="createdUser.value" search enter-button="Хайх">
      <Button
        @click="removeSelectedUser()"
        v-if="createdUser.value != ''"
        class=""
        slot="prepend"
      >
        <feather type="x" class="text-danger"></feather>
      </Button>
      <Button slot="append">
        <feather @click="createdUserFind" type="search"></feather>
      </Button>
    </Input>

    <template v-if="createdUser.curId != ''">
      <template v-if="createdUser.list.length > 0">
        <div
          @click="
            handleUserInfoModal(
              createdUser.list.filter(x => x.userId == createdUser.curId)[0].id
            )
          "
          class="alert alert-success mg-b-0 mg-t-10"
          role="alert"
          v-if="
            createdUser.list.filter(x => x.userId == createdUser.curId).length >
              0
          "
        >
          <span style="display:none">{{
            ($data["filterModel"][f.field] = createdUser.list.filter(
              x => x.userId == createdUser.curId
            )[0].userId)
          }}</span>
          <h6 class="alert-heading">Сонгогдсон хэрэглэгч!</h6>
          <p>
            {{
              createdUser.list.filter(x => x.userId == createdUser.curId)[0]
                .fullName
            }},
            {{
              createdUser.list.filter(x => x.userId == createdUser.curId)[0]
                .loginName
            }}
          </p>
        </div>
      </template>
    </template>
    <template v-else>
      <span style="display:none">{{
        ($data["filterModel"][f.field] = "00000000-0000-0000-0000-000000000000")
      }}</span>
    </template>

    <b-modal
      width="1000"
      hide-footer
      size="lg"
      scrollable
      v-model="createdUser.modal"
      title="Хэрэглэгч сонгох"
    >
      <div>
        <table class="wd-100p table-bordered table-striped">
          <thead>
            <tr>
              <th>№</th>
              <th>Төрөл</th>
              <th>Нэр</th>
              <th>Нэвтрэх нэр (Бүртгэл №)</th>
              <th>Регистр №</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              @click="handleUserInfoModal(u.id)"
              v-for="(u, i) in createdUser.list"
              :key="i"
              class="is-pointer"
            >
              <td>{{ i + 1 }}</td>
              <td>{{ u.locType4Name }}</td>
              <td>{{ u.fullName }}</td>
              <td>{{ u.loginName }}</td>
              <td>{{ u.register }}</td>
              <td class="text-right pd-r-5 pd-y-5">
                <button
                  @click.stop="chooseFromList(u.userId)"
                  type="button"
                  class="btn btn-outline-primary btn-xs"
                >
                  <span>Сонгох</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { request } from "@/api/all";

import "element-ui/lib/theme-chalk/index.css";
import {
  Input,
  FormItem,
  RadioGroup,
  Radio,
  Notification,
  Select,
  Option
} from "element-ui";
import { mapActions } from "vuex";

export default {
  components: {
    Input,
    FormItem,
    RadioGroup,
    Radio,
    Notification,
    Select,
    Option
  },
  props: {
    f: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      filterModel: {},
      createdUser: {
        mode: "1",
        value: "",
        list: [],
        modal: false,
        curId: ""
      }
    };
  },
  methods: {
    ...mapActions(["handleUserInfoModal"]),
    createdUserChanged(e) {
      this.createdUser.mode = e;
    },
    createdUserFind() {
      if (this.createdUser.mode == "1") {
        request({
          api: { url: "Hr/GetUsersByLoginName", method: "GET" },
          params: {
            loginName: this.createdUser.value
          },
          store: this.$store
        }).then(res => {
          if (res != false) {
            this.createdUserFindAfter(res);
          }
        });
      } else if (this.createdUser.mode == "2") {
        request({
          api: { url: "Hr/GetUsersByRegister", method: "GET" },
          params: {
            register: this.createdUser.value
          },
          store: this.$store
        }).then(res => {
          if (res != false) {
            this.createdUserFindAfter(res);
          }
        });
      } else if (this.createdUser.mode == "3") {
        request({
          api: { url: "Hr/GetUsersByFirstName", method: "GET" },
          params: {
            firstName: this.createdUser.value
          },
          store: this.$store
        }).then(res => {
          if (res != false) {
            this.createdUserFindAfter(res);
          }
        });
      }
    },
    createdUserFindAfter(res) {
      //console.log(res);
      this.createdUser.list = res.data.users;
      if (this.createdUser.list.length > 0) {
        if (this.createdUser.list.length == 1) {
          this.createdUser.curId = res.data.users[0].userId;
          this.handleuser();
        } else {
          this.createdUser.modal = true;
        }
      }
    },
    chooseFromList(uid) {
      this.createdUser.curId = uid;
      this.createdUser.modal = false;
      this.handleuser();
    },
    removeSelectedUser() {
      this.createdUser.value = "";
      this.createdUser.curId = "";
      this.handleuser();
    },
    handleuser() {
      this.$emit("on-handle", {
        field: this.f.field,
        val: this.createdUser.curId
      });
    }
  }
};
</script>

<style></style>
